import { render, staticRenderFns } from "./AssignLevelPremierContract.vue?vue&type=template&id=09148996&"
import script from "./AssignLevelPremierContract.vue?vue&type=script&lang=js&"
export * from "./AssignLevelPremierContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports